/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ClassroomdisciplineSharedClassRoomsQueryResponse,
  GetApiV1ClassroomdisciplineSharedClassRoomsQueryParams,
  GetApiV1ClassroomdisciplineSharedClassRooms401,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedClassRooms.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ClassroomdisciplineSharedClassRooms } from "../../clients/classPlanningSharedController/getApiV1ClassroomdisciplineSharedClassRooms.ts";

export const getApiV1ClassroomdisciplineSharedClassRoomsQueryKey = (
  params?: GetApiV1ClassroomdisciplineSharedClassRoomsQueryParams,
) =>
  [
    { url: "/api/v1/classroomdiscipline/shared/class-rooms" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ClassroomdisciplineSharedClassRoomsQueryKey = ReturnType<
  typeof getApiV1ClassroomdisciplineSharedClassRoomsQueryKey
>;

export function getApiV1ClassroomdisciplineSharedClassRoomsQueryOptions(
  params?: GetApiV1ClassroomdisciplineSharedClassRoomsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ClassroomdisciplineSharedClassRoomsQueryKey(params);
  return queryOptions<
    GetApiV1ClassroomdisciplineSharedClassRoomsQueryResponse,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedClassRooms401>,
    GetApiV1ClassroomdisciplineSharedClassRoomsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ClassroomdisciplineSharedClassRooms(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description  **(Requer Authorization para autenticação)**
 * @summary Lookup de salas ativas (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/shared/class-rooms}
 */
export function useGetApiV1ClassroomdisciplineSharedClassRooms<
  TData = GetApiV1ClassroomdisciplineSharedClassRoomsQueryResponse,
  TQueryData = GetApiV1ClassroomdisciplineSharedClassRoomsQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1ClassroomdisciplineSharedClassRoomsQueryKey,
>(
  params?: GetApiV1ClassroomdisciplineSharedClassRoomsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ClassroomdisciplineSharedClassRoomsQueryResponse,
        ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedClassRooms401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ClassroomdisciplineSharedClassRoomsQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ClassroomdisciplineSharedClassRoomsQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedClassRooms401>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
